import { render, staticRenderFns } from "./purparttype.vue?vue&type=template&id=0c47104e&scoped=true&"
import script from "./purparttype.vue?vue&type=script&lang=js&"
export * from "./purparttype.vue?vue&type=script&lang=js&"
import style0 from "./purparttype.vue?vue&type=style&index=0&id=0c47104e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47104e",
  null
  
)

export default component.exports